module.exports = flarum.core.compat['components/Page'];